import { CourseScheduleActivityApi, courseschedulesApi } from "api/courseSchedulesApi";
import { useEffect, useState } from "react";

export const useCourseScheduleHistory = (courseId: number | string | undefined) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<CourseScheduleActivityApi[]>([]);

  const fetchResource = async () => {
    if (!courseId) {
      setLoading(false);
      return;
    }
    try {
      const res = await courseschedulesApi.fetchHistory(Number(courseId));
      setData(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResource();
  }, [courseId]);

  return { loading, data, refresh: fetchResource };
};
